export function debucketizeImageUrl(url: string) {
  return url
    .replace(
      'https://storage.googleapis.com/dcd-web-cms-resources-storage',
      'https://images.decodo.com'
    )
    .replace(
      'https://storage.googleapis.com/images.decodo.com',
      'https://images.decodo.com'
    )
    .replace(
      'https://storage.googleapis.com/images.smartproxy.com',
      'https://images.decodo.com'
    )
    .replace(
      'https://storage.googleapis.com/sp-cms-web-resources',
      'https://images.decodo.com'
    );
}
